module.exports = __webpack_public_path__ + "img/mty-cultures.40382168.png";